import { render, staticRenderFns } from "./SendForm.vue?vue&type=template&id=8eb055de"
import script from "./SendForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SendForm.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports